// extracted by mini-css-extract-plugin
module.exports = {"copyButton":"copyEntityButton_copyButton__3fItK","copyEntityIcon":"copyEntityButton_copyEntityIcon__Mjn2C","copyButtonTooltip":"copyEntityButton_copyButtonTooltip__2m8Mx"};